@use '../../../../tti-design-styles/src/molecules/status-overview-bars' as *;

:host {
   display: block;
}
